/* import __COLOCATED_TEMPLATE__ from './channel-limit.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import type AppConversationCapacityLimit from 'embercom/models/app-conversation-capacity-limit';

type ChannelType = 'email' | 'messenger';

interface ChannelLimits {
  email?: number;
  messenger?: number;
}

interface WorkloadManagementSettings {
  channel_limits?: ChannelLimits | null;
}

interface Admin {
  workload_management_settings?: WorkloadManagementSettings;
}

interface Signature {
  Args: {
    admin: Admin;
    workspaceSettings: AppConversationCapacityLimit;
    channelType: ChannelType;
  };
  Element: HTMLDivElement;
}

export default class ChannelLimit extends Component<Signature> {
  get channelLimit(): number | null | undefined {
    return this.args.admin?.workload_management_settings?.channel_limits?.[this.args.channelType];
  }

  get currentWorkspaceLimit(): number | undefined {
    return (
      this.args.workspaceSettings?.channelLimits?.[this.args.channelType] ??
      this.args.workspaceSettings?.capacityLimit ??
      0
    );
  }

  get hasCustomLimit(): boolean {
    return this.channelLimit !== undefined && this.channelLimit !== null;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox::TeammateWorkload::ChannelLimit': typeof ChannelLimit;
    'inbox/teammate-workload/channel-limit': typeof ChannelLimit;
  }
}
